<!--
 * @Author: 范向玲
 * @Date: 2022-12-20 17:36:14
 * @LastEditors: chenmengnan chenmengnan@piesat.cn
 * @LastEditTime: 2025-10-21 10:45:54
 * @Description: 文件上传
 * @FilePath: \web\src\components\lib\Upload\fileUpload1.vue
-->
<template>
  <section class="file-upload-container">
    <section class="fileDown" @click="importFileDown">数据模板下载</section>
    <a-upload v-model:file-list="optionConf.fileList" name="file" accept=".xlsx,.xls" :showUploadList="true"
      @change="handleChange" :before-upload="beforeUpload" :remove="handleRemove">
      <a-button>文件上传</a-button>
    </a-upload>
  </section>
</template>

<script setup>
import { ref, reactive, defineEmits, toRefs, watch, onMounted, defineProps } from 'vue';
import { message } from 'ant-design-vue';

const props = defineProps({
  uploadType: {
    type: String,
  },
});

// emit
const emit = defineEmits(['fileList']);

const optionConf = reactive({
  fileList: [],
});
/* 文件上传模板下载 */
const importFileDown = () => {
  //   接口未调试
  const http = window.location.protocol;
  const baseUrl = http + '//' + window.location.hostname;

  if (props.uploadType === 'cl') {
    window.open(baseUrl + ':8080/template/产量导入模版.xlsx');
  } else if (props.uploadType === 'pl') {
    window.open(baseUrl + ':8080/template/储量导入模版.xlsx');
  } else if (props.uploadType === 'xfl') {
    window.open(baseUrl + ':8080/template/消费量导入模版.xlsx');
  } else if (props.uploadType === 'xmk') {
    window.open(baseUrl + ':8080/template/矿业项目库导入模板.xlsx');
  } else if (props.uploadType === 'td') {
    window.open(baseUrl + ':8080/template/贸易量导入模板.xlsx');
  } else {
    message.error('无模板');
  }

  // ccxmFileDownApi()
  //   .then((res) => {
  //     downLoadUtil(res).then(() => {});
  //   })
  //   .catch(() => {});
};
/**
 * @description 阻止选择文件自动上传
 */
// const beforeUpload = (file) => {
//   return false;
// };
/**
 * @description 导入文件修改
 */
//   文件上传
const fileList = ref([]);
const uploading = ref(false);
const handleRemove = (file) => {
  const index = fileList.value.indexOf(file);
  const newFileList = fileList.value.slice();

  newFileList.splice(index, 1);
  fileList.value = newFileList;
};
const beforeUpload = (file) => {
  // console.log(fileList.value,file)

  // fileList.value = [...fileList.value, file];
  // emit('fileList', file.fileList);
  return false;
};

const handleChange = (file) => {
  // fileList.value = [file];
  // console.log(fileList,file)
  emit('fileList', file.fileList);

  // emit('fileList', optionConf.fileList);
};

</script>

<style lang="scss">
.file-upload-container {
  .ant-upload-list-item-name {
    padding-left: 0;
    color: #fff;
  }

  /* 模板下载 */
  .fileDown {
    width: 20%;
    height: 0.3rem;
    line-height: 0.3rem;
    text-align: center;
    background-image: url(~@/static/images/dataManagement/submit_btn.png);
    background-size: 100% 100%;
    margin-bottom: 0.1rem;
  }

  .fileDown:hover {
    cursor: pointer;
  }

  /* 文件上传 */
  .fileUpload {
    margin-top: 0.1rem;
  }

  // 文件列表悬浮样式修改
  .ant-upload-list-item:hover .ant-upload-list-item-info {
    background-color: rgba(140, 100, 30, 0.4);
  }

  .ant-upload-list-item-card-actions .anticon {
    color: #fff;
  }

  .ant-upload-list-item-error .ant-upload-list-item-card-actions .anticon {
    color: red;
  }
}
</style>
